import React, { useEffect, useState } from 'react'

import { Nav } from 'react-bootstrap'
import { useLazyQuery } from '@apollo/client'
import PropTypes from 'prop-types'
import playerImg from '@assets/images/placeholder/Placeholder_Player.svg'
import flagTeam from '@assets/images/placeholder/team-placeholder.svg'
import styles from './style.module.scss'
import tableItemStyles from '@assets/scss/components/table-item.module.scss'
import { RANKINGS } from '@graphql/globalwidget/rankings.query'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import CustomLink from '../customLink'
import WidgetCardHeader from '../widgets/widgetHeader'
import MyImage from '../myImage'
import { getMediaImgURL } from '@shared/constants/utils'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'

const RankingTab = ({ dataSSR }) => {
  const [firstTime, setFirstTime] = useState(true)
  const [filter, setFilter] = useState({ eMatchType: 'Tests', eRankType: 'Teams', nLimit: 5, nSkip: 0 })
  const [rankings, setRankings] = useState(dataSSR?.getRankings?.aResults || [])
  const [getRankings, { data: newData, loading }] = useLazyQuery(RANKINGS, { context: { headers: { 'Cache-Control': 'public, max-age=300, s-maxage=600, stale-while-revalidate=420' } } })
  useEffect(() => {
    if (firstTime) {
      !dataSSR && getRankings({
        variables: { input: filter }
      })
      setFirstTime(false)
    } else {
      getRankings({
        variables: { input: filter }
      })
    }
  }, [filter])

  useEffect(() => {
    if (newData) {
      setRankings(newData?.getRankings?.aResults)
    }
  }, [newData])

  const handleRankFilter = (value) => {
    setFilter({ ...filter, eRankType: value })
  }
  const handleMatchFilter = (value) => {
    setFilter({ ...filter, eMatchType: value })
  }
  return (
    <>
      <div className={`${styles.rankingTab} widget`}>
         <WidgetCardHeader headerText={'ICC Rankings'} link={allRoutes.iccRankings} internalLink={true} />
        <div className={styles.tabContainer}>
          <Nav className={`${styles.simpleTab} simple-tab`}>
            <Nav.Item>
              <Nav.Link className={`${filter.eRankType === 'Teams' && 'active text-active font-bold'} nav-link`} onClick={() => handleRankFilter('Teams')}>
                {'Teams'}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className={`${filter.eRankType === 'Batsmen' && 'active text-active font-bold'} nav-link`} onClick={() => handleRankFilter('Batsmen')}>
                {'Batting'}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className={`${filter.eRankType === 'Bowlers' && 'active text-active font-bold'} nav-link`} onClick={() => handleRankFilter('Bowlers')}>
                {'Bowling'}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className={`${filter.eRankType === 'AllRounders' && 'active text-active font-bold'} nav-link`}
                onClick={() => handleRankFilter('AllRounders')}
              >
                {'ALR'}
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Nav className={`${styles.navTab} text-uppercase equal-width-nav`} variant="pills">
            <Nav.Item>
              <Nav.Link className={`${filter.eMatchType === 'Tests' && 'active'} nav-link`} onClick={() => handleMatchFilter('Tests')}>
                {'Test'}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className={`${filter.eMatchType === 'Odis' && 'active'} nav-link`} onClick={() => handleMatchFilter('Odis')}>
                {'ODI'}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className={`${filter.eMatchType === 'T20s' && 'active'} nav-link`} onClick={() => handleMatchFilter('T20s')}>
                {'T20i'}
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <div className={tableItemStyles.itemCard}>
            {/* <div className={`${tableItemStyles.item} ${tableItemStyles.head} d-flex align-items-center`}>
              <p className="mb-0">{"Rank"}</p>
              <p className="mb-0 flex-grow-1">{filter.eRankType !== 'Teams' ? 'Player' : 'Team'}</p>
              <p className="mb-0">{"Rating"}</p>
            </div> */}
            {/* {loading && [0, 1, 2, 3, 4].map((s) => {
              return (
                <div key={s} className={`${tableItemStyles.item} d-flex align-items-center `}>
                  <Skeleton height={'20px'} className="mb-0 flex-shrink-0" />
                  <Skeleton height={'20px'} width={'40%'} className={`${tableItemStyles.itemDesc} d-flex align-items-center p-0 ms-3 me-auto`} />
                  <Skeleton height={'20px'} className="mb-0 flex-shrink-0" />
                </div>
              )
            })} */}
            {!loading && rankings?.length === 0 && (
              <div className={tableItemStyles.item}>
                <p className="mb-0 w-100">{'No Data Found'}</p>
              </div>
            )}
            {rankings?.map((element) => {
              return (
                <div key={element._id} className={`${tableItemStyles.item} d-flex align-items-center `}>
                  <div className={`${styles.cardTeamLogo} overflow-hidden`}>
                        <MyImage
                    src={element?.oTeams?.oImg?.sUrl ? getMediaImgURL(element?.oTeams?.oImg?.sUrl) : getMediaImgURL(element?.oPlayer?.oImg?.sUrl)}
                          alt="user"
                          blurDataURL={BLUR_DATA_URL_BASE64}
                          placeholder="blur"
                          layout="fixed"
                          width="26"
                          height="26"
                          autoRadiusImage
                          errorImage={element?.oTeams?.oImg?.sUrl ? flagTeam : playerImg}
                        />
                      </div>
                  <div className={`${tableItemStyles.itemDesc} d-flex align-items-center flex-grow-1`}>
                    {/* <div className={`${tableItemStyles.itemImg} flex-shrink-0`}>
                    <MyImage src={playerImg} width={80} height={80} alt={name} layout="responsive" />
                  </div> */}
                    <div>
                      <p className={`${styles.title} mb-0`}>
                        {
                          element?.oPlayer?.eTagStatus === 'a' && element?.oPlayer?.oSeo?.eStatus === 'a' && element?.oPlayer?.oSeo?.sSlug ? (
                            <CustomLink href={`/${element?.oPlayer?.oSeo?.sSlug}`}>{element.sName}
                            </CustomLink>
                          ) : (
                            <CustomLink href={`/${element?.oTeams?.oSeo?.sSlug}`}>{element.sName}
                            </CustomLink>
                          )
                        }
                      </p>
                      {/* {filter.eRankType !== 'Teams' && <p className={tableItemStyles.subText}>{element.sTeam}</p>}
                    {filter.eRankType === 'Teams' && (
                      <p className={tableItemStyles.subText}>
                        {"Points"}: {element.nPoints}
                      </p>
                    )} */}
                    </div>
                  </div>
                  <p className={`${styles.rating} mb-0 flex-shrink-0`}>{element.nRating}</p>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

RankingTab.propTypes = {
  dataSSR: PropTypes.object
}

export default RankingTab
